import { styled, Typography } from "@mui/material";
import BasicSelect from "components/BasicInputs/BasicSelect";

export const BoxUpperContainer = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "15px",
  height: "64px",
  alignItems: "center",
  borderBottom: `solid 4px ${theme.palette.disabled.light}`,
  justifyContent: "space-between",
}));

interface Props {
  title?: string;
  options?: Option[];
  onChange?: (filterType: string) => void;
}

export const BoxUpper = ({ title, options, onChange }: Props) => {
  return (
    <BoxUpperContainer>
      <Typography fontWeight="bold">{title}</Typography>
      {options && (
        <div style={{ width: "150px" }}>
          <BasicSelect options={options} onChange={onChange} placeholder={options[0]?.label} noVirtual />
        </div>
      )}
    </BoxUpperContainer>
  );
};
